import { useMemo } from 'react';
import { SecurityScoreEnum } from '../../enums';
import {
  AG3, AG4, AO1, AO2, AO4, AR1, AR2, AR4, AG1, AG2,
} from '../../theme';

export interface IUseSecurityScoreParams {
  score: number,
}

export const useSecurityScore = (params: IUseSecurityScoreParams) => {
  const { score } = params;

  const {
    color,
    backgroundColor,
    translationKey,
    widgetColor,
    widgetAdditionalColor,
    widgetTranslationKey,
  } = useMemo(() => {
    switch (true) {
      case (score <= SecurityScoreEnum.VeryWeak):
        return {
          color: AR2,
          backgroundColor: AR4,
          translationKey: 'securityScore.veryWeak',
          widgetColor: AR2,
          widgetAdditionalColor: AR1,
          widgetTranslationKey: 'securityScore.veryWeak',
        };
      case (score <= SecurityScoreEnum.Weak):
        return {
          color: AR2,
          backgroundColor: AR4,
          translationKey: 'securityScore.weak',
          widgetColor: AR2,
          widgetAdditionalColor: AR1,
          widgetTranslationKey: 'securityScore.weak',
        };
      case (score <= SecurityScoreEnum.Medium):
        return {
          color: AO4,
          backgroundColor: AO1,
          translationKey: 'securityScore.medium',
          widgetColor: AO4,
          widgetAdditionalColor: AO2,
          widgetTranslationKey: 'securityScore.medium',
        };
      case (score <= SecurityScoreEnum.Strong):
        return {
          color: AG3,
          backgroundColor: AG4,
          translationKey: 'securityScore.strong',
          widgetColor: AG2,
          widgetAdditionalColor: AG1,
          widgetTranslationKey: 'securityScore.strong',
        };
      default:
        return {
          color: AG3,
          backgroundColor: AG4,
          translationKey: 'securityScore.veryStrong',
          widgetColor: AG2,
          widgetAdditionalColor: AG1,
          widgetTranslationKey: 'securityScore.veryStrong',
        };
    }
  }, [score]);

  return {
    color,
    backgroundColor,
    translationKey,
    widgetColor,
    widgetAdditionalColor,
    widgetTranslationKey,
  };
};

export default useSecurityScore;
